import * as React from "react";
import { forwardRef } from "react";
const SvgSkipMedium = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 11, fill: "currentColor", stroke: "#0F172A", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M8.5 12L15.5 12", stroke: "white", strokeWidth: 2, strokeLinejoin: "bevel" }));
const ForwardRef = forwardRef(SvgSkipMedium);
export { ForwardRef as ReactComponent };
